import FadeInBox from '@/components/common/FadeInBox';
import { FlexRow } from '@/components/common/Flex';
import PlentyLogo from '@/components/common/PlentyLogo';
import { IdvProgressBar } from '@/components/idv/IdvProgressBar';
import { useIdvContext } from '@/components/idv/IdvProvider';
import { ProfileView } from '@/components/idv/views/ProfileView';
import { FlexCol } from '../common/Flex';
import { VGSProvider } from '../common/VGSProvider';
import IdvLayout from './IdvLayout';
import {
    AddressView,
    AvoidIndustriesView,
    CitizenshipView,
    ConflictOfInterestView,
    DownturnReactionView,
    EmployerAddressView,
    EmploymentStatusView,
    IndividualConsentView,
    InvestmentPriorityView,
    SummaryView,
    SupportedValuesView,
} from './views';

const routes = [
    { route: 'profile', component: <ProfileView /> },
    { route: 'address', component: <AddressView /> },
    {
        route: 'citizenship',
        component: (
            <VGSProvider>
                <CitizenshipView />
            </VGSProvider>
        ),
    },
    { route: 'employment-status', component: <EmploymentStatusView /> },
    { route: 'employer-address', component: <EmployerAddressView /> },
    {
        route: 'conflict-of-interest',
        component: <ConflictOfInterestView />,
    },
    {
        route: 'investment-priority',
        component: <InvestmentPriorityView />,
    },
    {
        route: 'investment-downturn-reaction',
        component: <DownturnReactionView />,
    },
    {
        route: 'investment-supported-values',
        component: <SupportedValuesView />,
    },
    {
        route: 'investment-avoid-industries',
        component: <AvoidIndustriesView />,
    },
    { route: 'summary', component: <SummaryView /> },
    { route: 'consent', component: <IndividualConsentView /> },
];

const IdvNavigator = () => {
    const { includeInviteStep, position } = useIdvContext();

    return (
        <IdvLayout>
            <FlexCol flex={1} px={10} overflow="hidden">
                <FlexRow justify="space-between" align="center" mb={8}>
                    <PlentyLogo />
                    <IdvProgressBar includeInviteStep={includeInviteStep} />
                </FlexRow>
                <FlexCol basis={0} grow={1} position="relative">
                    {routes.map(({ route, component }, i) => {
                        if (position === route) {
                            return (
                                <FadeInBox key={i} w="full" h="full">
                                    {component}
                                </FadeInBox>
                            );
                        }
                    })}
                </FlexCol>
            </FlexCol>
        </IdvLayout>
    );
};

export default IdvNavigator;
